import { css } from '@emotion/react';
import { LucidTheme, mqMax } from '@lucid/theme';

import { bounceIn } from 'theme/keyframes';

export const backgroundGrayPattern = css({
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    background:
      "url('https://d2slcw3kip6qmk.cloudfront.net/marketing/pages/chart/Homepage/background.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    zIndex: -99,
    height: '100%',
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  }
});

type BounceDetection = {
  theme: LucidTheme,
  loaded?: boolean,
  header?: boolean,
  body?: boolean,
  close?: boolean,
  survey?: boolean
};

export const bounceDetection = ({
  theme,
  loaded = false,
  header = false,
  body = false,
  close = false,
  survey = false
}: BounceDetection) => css([
  {
    background: theme.colors.white,
    padding: `${theme.space[4]}px ${theme.space[6]}px ${theme.space[6]}px`,
    borderRadius: theme.radii.base,
    width: '512px',
    outline: 'none',
    margin: 'auto',
    position: 'relative',
    color: theme.colors.coolGrey[80],
    opacity: 1,
    animationName: bounceIn,
    animationIterationCount: 1,
    animationTimingFunction: 'ease',
    animationDuration: '0.25s',
    [mqMax.mobile]: {
      padding: theme.space[3]
    },
    '& em': {
      textDecoration: 'underline'
    }
  },
  loaded && {
    opacity: 1
  },
  header && {
    fontSize: theme.fontSizes[5],
    fontWeight: theme.fontWeights.stronger
  },
  body && {
    fontSize: theme.fontSizes[3]
  },
  close && {
    position: 'absolute',
    top: theme.space[2],
    right: theme.space[2],
    outline: 'none',
    border: 0,
    color: theme.colors.coolGrey[30],
    fontSize: theme.fontSizes[3],
    background: 'transparent',
    '&:hover': {
      cursor: 'pointer',
      color: theme.colors.indigo[60]
    }
  },
  survey && {
    width: '600px',
    maxWidth: '100%',
    'iframe': {
      width: '100%',
      height: '500px',
      minHeight: '368px',
      maxHeight: '85vh'
    }
  }
]);
